























































import { Component, Vue } from "vue-property-decorator";
import baseSpinner from '@/components/Spinner';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import CustomButton from '@/components/Globals/CustomButton.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import ImageGallery from '@/components/molecule.imageGallery.vue';
import ImageGalleryContinueAndEditView from '@/components/molecule.imageGallery.continueAndEditView.vue';
import { IAddYourImageGalleryItems, IGalleryItemsImgList } from "./Globals/types/ugc.t";

import ugc from '@/mixins/UGC'
import imageLibrary from '@/mixins/imageLibrary';

@Component({
  components: {
    CustomButton,
    CustomContainer,
    CustomModal,
    ImageGallery,
    ImageGalleryContinueAndEditView,
    ModalHeader,
    baseSpinner
  },
  mixins: [ugc, imageLibrary]
})
export default class AddYourImageGallery extends Vue {
  [x: string]: any;

  showCloseModal = true as boolean;

  get translations() {
    return (
      this.$store.state.translations?.data?.modals?.addYourImageGallery || {}
    );
  }

  onDataLoading(loading: boolean = true): void {
    this.isPreviewDataLoading = loading;
    this.$store.commit("ugc/tempData/HAS_FINISHED_APPLYING", !loading);
  }

  onShowCloseIcon(show: boolean): void {
    this.showCloseModal = show;
  }

  beforeOpenModal(event: any): void {
    const { categories } = event.params || [];
    const { features, activeUGCIndex } = this.$store.state.ugc.tempData;
    const isSecondaryComponentFlow = this.$store.getters["imageGallery/isSecondComponentFlow"];
    let componentName = '';
    if (features[activeUGCIndex].selectAnother || isSecondaryComponentFlow) {
      const secondaryComponentName = this.$store.getters[
        "ugc/getUGCComponentNotActive"
      ];
      if (!!secondaryComponentName) componentName = secondaryComponentName;
    }
    this.setInitialData();
    // TODO load only if changed/needed
    this.loadImages({categories, componentName})
      .then((gallery: IAddYourImageGalleryItems) => {
        this.isPreviewDataLoading = false;
      });
  }

  beforeClose(): void {
    const { features, activeUGCIndex } = this.$store.state.ugc.tempData;
    const { selectAnother } = features[activeUGCIndex];
    const { isBackToLibraryApplied } = this.$store.state.imageGallery;
    // TODO placements on 2nd component flow
    const isSecondaryComponentFlow = this.$store.getters["imageGallery/isSecondComponentFlow"];
    if (!selectAnother && !isSecondaryComponentFlow && !isBackToLibraryApplied) {
      this.$store.commit("ugc/placements/CLEAR_ALL");
    }
  }

  exitLibraryModal() {
    this.$ugcDataLayer.logAnalyticsEvent({
      action: 'imageLibrary',
      eventLabel: 'Close Modal',
    });
    // If opened from the reposition flow and on image-gallery view, open the buyPanel on close
    if (this.storeMultipleUGCsizes) {
      const { ugcSize } = this.$store.state.buyPanel;
      this.$store.commit("buyPanel/REPLACE_SIZE_SELECTED", ugcSize);
      this.$store.commit('ugc/tempData/SET_STORE_MULTIPLE_UGC_SIZES', false);
      this.onCloseModal();
      this.$eventBus.$emit('show-buy-panel');
    } else {
      this.onCloseModal();
    }
  }

  closeModal() {
    this.showCTAButton = false;
    this.showCloseModal = true;
  }

  onCloseModal(){
    this.clearData();
    this.$modal.hide('addYourImageGallery');
  }

  setModalDimensions() {
    if(!this.isMobile) {
      this.widthModal = "75%";
      this.heightModal = "auto";
    } else {
      this.widthModal = "100%";
      this.heightModal = "100%";
    }
  }

  created() {
    this.$eventBus.$once("preloader-finished-loading", this.checkLibraryEntryPoint);
    this.$eventBus.$on('replace-image-library-tool', this.replaceImageLibraryTool);
    this.$eventBus.$on('select-another-image-assets', this.imageLibrarySelectAnother);
    this.$eventBus.$on("update-component-image-library", this.saveComponentEditFlow);
    this.$eventBus.$on('finish-image-library-edit', this.finishLibraryEditFlow);
    this.$eventBus.$on('image-library-same-image', this.applySecondComponent);
    this.$eventBus.$on('image-library-reset-states', this.clearData);
    this.$eventBus.$on('start-reposition-image-library', this.startRepositionFlowLibrary);
  }

  mounted() {
    this.isPreviewDataLoading = true;
    this.setModalDimensions();
  }

  destroyed() {
    this.$eventBus.$off('replace-image-library-tool', this.replaceImageLibraryTool);
    this.$eventBus.$off('select-another-image-assets', this.imageLibrarySelectAnother);
    this.$eventBus.$off("update-component-image-library", this.saveComponentEditFlow);
    this.$eventBus.$off('finish-image-library-edit', this.finishLibraryEditFlow);
    this.$eventBus.$off('image-library-same-image', this.applySecondComponent);
    this.$eventBus.$off('image-library-reset-states', this.clearData);
    this.$eventBus.$off('start-reposition-image-library', this.startRepositionFlowLibrary);
  }
}
